import BaseService from './BaseService';
import entities from 'src/config/entities';

class InvoiceService extends BaseService {

  constructor () {
    super({entity: entities.INVOICE});
  }

  async generateInvoiceForClient(data) {
    try {

      let res = await this.instance.post('/invoice-by-client', data)
      this._handleSuccess({ translationKey: 'generic.create.success', res});
      return res;
    } catch (e) {
      this._handleError({ translationKey: 'generic.create.error', error: e});
      throw e;
    }
  }

  async updateInvoiceStatus(id, status) {
    try {

      let res = await this.instance.put(`/${id}/status`, { status })
      this._handleSuccess({ translationKey: 'generic.update.success', res});
      return res;
    } catch (e) {
      this._handleError({ translationKey: 'generic.update.error', error: e});
      throw e;
    }
  }
}

export default new InvoiceService();
